export const CMS_URL = 'https://cms.kojiesan.vn'
